import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-013cdcda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-col settings-content-inner-column text-Text/text_high" }
const _hoisted_2 = { class: "flex flex-wrap pt-6" }
const _hoisted_3 = { class: "flex-col" }
const _hoisted_4 = { class: "setting-content-input-title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Max cores per build", -1))
const _hoisted_6 = { class: "ml-6 flex-col" }
const _hoisted_7 = { class: "setting-content-input-title" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Max CPU load", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-Text/text_low" }, "%", -1))
const _hoisted_10 = { class: "flex flex-wrap pt-8" }
const _hoisted_11 = { class: "flex-col" }
const _hoisted_12 = { class: "setting-content-input-title" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Min free memory", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-Text/text_low" }, "MB", -1))
const _hoisted_15 = { class: "ml-6 flex-col" }
const _hoisted_16 = { class: "setting-content-input-title" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Machine reload timeout", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-Text/text_low" }, "sec", -1))
const _hoisted_19 = { class: "flex flex-col flex-wrap pt-8" }
const _hoisted_20 = { class: "flex setting-content-input-title" }
const _hoisted_21 = { class: "flex setting-content-input-title" }
const _hoisted_22 = { class: "text-Text/text_low gordita-400-12" }
const _hoisted_23 = { class: "flex flex-wrap pt-6" }
const _hoisted_24 = { class: "flex-col" }
const _hoisted_25 = { class: "setting-content-input-title" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Hostname or IP", -1))
const _hoisted_27 = { class: "ml-6 flex-col" }
const _hoisted_28 = { class: "setting-content-input-title" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Port", -1))
const _hoisted_30 = { class: "flex flex-wrap mb-8 pt-8" }
const _hoisted_31 = { class: "flex-col" }
const _hoisted_32 = { class: "setting-content-input-title" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Timeout", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-Text/text_low" }, "sec", -1))
const _hoisted_35 = { class: "ml-6 flex-col" }
const _hoisted_36 = { class: "setting-content-input-title" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Sync frequency", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-Text/text_low" }, "sec", -1))
const _hoisted_39 = { class: "flex-col settings-content-inner-column" }
const _hoisted_40 = { class: "flex flex-wrap pt-6" }
const _hoisted_41 = { class: "flex-col" }
const _hoisted_42 = { class: "setting-content-input-title" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Coordinator utility port", -1))
const _hoisted_44 = { class: "ml-6 flex-col" }
const _hoisted_45 = { class: "setting-content-input-title" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Coordinator session port", -1))
const _hoisted_47 = { class: "flex flex-wrap pt-8" }
const _hoisted_48 = { class: "flex-col" }
const _hoisted_49 = { class: "setting-content-input-title" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Coordinator UI port", -1))
const _hoisted_51 = { class: "ml-6 flex-col" }
const _hoisted_52 = { class: "setting-content-input-title" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Agent control port", -1))
const _hoisted_54 = { class: "flex flex-wrap pt-6" }
const _hoisted_55 = { class: "flex-col" }
const _hoisted_56 = { class: "setting-content-input-title" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Agent webserver port", -1))
const _hoisted_58 = { class: "ml-6 flex-col" }
const _hoisted_59 = { class: "setting-content-input-title" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "HTTPS agent webserver port", -1))
const _hoisted_61 = { class: "flex flex-wrap pt-8" }
const _hoisted_62 = { class: "flex setting-content-input-title" }
const _hoisted_63 = { class: "flex flex-wrap pt-6" }
const _hoisted_64 = { class: "flex-col" }
const _hoisted_65 = { class: "flex setting-content-input-title" }
const _hoisted_66 = { class: "mt-[8px]" }
const _hoisted_67 = { class: "text-[12px] text-Text/text_low" }

import { increaseDecreaseArrowsButton, IncrediField } from 'incredi-ui';
import TooltipBtn from '@/components/common/TooltipBtn.vue';
import IncrediCheckBox from '@/components/inputs/incrediCheckBox.vue';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { computed, inject, PropType } from 'vue';
import { useUserRolePermissions } from '@/services/UserRolePermissions/UserRolePermissions';
import { QUERY_RESULT_PATH, SettingsPageLinuxQuery, useCommonDataQuery } from '@/graphql/codegen/generated/graphql';
import { IKSettingsDirty, IKSettingsLinuxValidatePorts, IKSettingsLinuxValidInputs, IKSettingsValidPorts } from '@/types/injectionKeys';
import elementsIds from '@/const/elementIds.json';
import SettingsPortInput from '@/views/settings/components/settingsPortInput.vue';
import { useSettingsErrorMessages } from '@/views/settings/settings.helpers';
import { SETTINGS_OBJ } from '@/views/settings/const';
import SettingsActiveDirectory from '@/views/settings/components/settingsActiveDirectory.vue';
import { FeatureFlags } from '@/types/utils';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import { Settings_ExternalAuth } from '@/graphql/codegen/gql/graphql';
import SettingsItemBox from '../../components/settings-item-box.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'settings-general.linux',
  props: {
  settingsObject: {
    type: Object as PropType<NonNullable<SettingsPageLinuxQuery['ibManagerEntities']>>,
    required: true,
  },
},
  setup(__props) {



const userRolePermissions = useUserRolePermissions();
const settingsDirty = inject(IKSettingsDirty);
const validInputs = inject(IKSettingsLinuxValidInputs);
const validateApachePorts = inject(IKSettingsLinuxValidatePorts);
const validPorts = inject(IKSettingsValidPorts);
const coordinatorsService = inject(IKCoordinatorsService);
const { getPositivePortValidationErrorMessage } = useSettingsErrorMessages();
const GQL_CommonData = useCommonDataQuery(() => ({ coordinatorId: coordinatorsService?.selectedCoordinator.value || '' }));

const featureFlags = computed<FeatureFlags>(() => (GQL_CommonData?.result?.value?.ibManagerEntities?.featureFlags ? JSON.parse(GQL_CommonData?.result?.value?.ibManagerEntities?.featureFlags) : null));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, { class: "settings-content-inner flex flex-wrap" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(SettingsItemBox, {
          class: "w-full",
          header: _ctx.$t('settings.general.system.title')
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createVNode(TooltipBtn, {
                    "tooltip-width": 207,
                    "btn-icon": "icon-question-circle",
                    class: "ml-0.5 mb-0.5 tooltip-btn",
                    "tooltip-title": _ctx.$t('settings.general.linux.tooltipText.coordinator.buildMaxCores')
                  }, null, 8, ["tooltip-title"])
                ]),
                _createVNode(_unref(IncrediField), {
                  "data-testid": _unref(elementsIds).settings.form.linux.general.maxCoresPerBuild,
                  disabled: !_unref(userRolePermissions).authorize?.value?.settings.enabled.general,
                  autocomplete: "off",
                  name: "description",
                  label: "Max Cores",
                  type: "number",
                  size: "tiny",
                  class: "input-container",
                  modelValue: 
                __props.settingsObject?.settings?.linux?.coordinator?.buildMaxCores || __props.settingsObject?.settings?.linux?.coordinator?.buildMaxCores === 0
                  ? __props.settingsObject?.settings?.linux?.coordinator?.buildMaxCores
                  : ''
              ,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = 
                      (val) => {
                        _unref(settingsDirty)?.setInputsDirty(_unref(QUERY_RESULT_PATH).settings.linux.coordinator.buildMaxCores, val !== undefined ? val : '');
                      }
                    )
                }, null, 8, ["data-testid", "disabled", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(TooltipBtn, {
                    "tooltip-width": 207,
                    "btn-icon": "icon-question-circle",
                    class: "ml-0.5 mb-0.5 tooltip-btn",
                    "tooltip-title": _ctx.$t('settings.general.linux.tooltipText.coordinator.agentMaxCpuLoad')
                  }, null, 8, ["tooltip-title"])
                ]),
                _createVNode(_unref(IncrediField), {
                  "data-testid": _unref(elementsIds).settings.form.linux.general.maxCPULoad,
                  disabled: !_unref(userRolePermissions).authorize?.value?.settings.enabled.general,
                  autocomplete: "off",
                  name: "description",
                  label: "Max CPU load",
                  type: "number",
                  size: "tiny",
                  class: "input-container",
                  error: _unref(validInputs)?.['settings.linux.coordinator.agentMaxCpuLoad'].isValid === false,
                  "error-message": _ctx.$t('settings.general.linux.validationsErrors.range'),
                  modelValue: 
                __props.settingsObject?.settings?.linux?.coordinator?.agentMaxCpuLoad || __props.settingsObject?.settings?.linux?.coordinator?.agentMaxCpuLoad === 0
                  ? __props.settingsObject?.settings?.linux?.coordinator?.agentMaxCpuLoad
                  : ''
              ,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = 
                      (val) => {
                        _unref(settingsDirty)?.setInputsDirty(_unref(QUERY_RESULT_PATH).settings.linux.coordinator.agentMaxCpuLoad, val !== undefined ? val : '');
                      }
                    )
                }, {
                  postpend: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }, 8, ["data-testid", "disabled", "error", "error-message", "modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(TooltipBtn, {
                    "tooltip-width": 207,
                    "btn-icon": "icon-question-circle",
                    class: "ml-0.5 mb-0.5 tooltip-btn",
                    "tooltip-title": _ctx.$t('settings.general.linux.tooltipText.coordinator.agentMinFreeMemory')
                  }, null, 8, ["tooltip-title"])
                ]),
                _createVNode(_unref(IncrediField), {
                  "data-testid": _unref(elementsIds).settings.form.linux.general.minFreeMemory,
                  disabled: !_unref(userRolePermissions).authorize?.value?.settings.enabled.general,
                  autocomplete: "off",
                  name: "description",
                  label: "Min free memory",
                  type: "number",
                  size: "tiny",
                  class: "input-container",
                  error: _unref(validInputs)?.['settings.linux.coordinator.agentMinFreeMemory'].isValid === false,
                  "error-message": _ctx.$t('settings.general.linux.validationsErrors.positiveNumbers'),
                  modelValue: 
                __props.settingsObject?.settings?.linux?.coordinator?.agentMinFreeMemory || __props.settingsObject?.settings?.linux?.coordinator?.agentMinFreeMemory === 0
                  ? __props.settingsObject?.settings?.linux?.coordinator?.agentMinFreeMemory
                  : ''
              ,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = 
                      (val) => {
                        _unref(settingsDirty)?.setInputsDirty(_unref(QUERY_RESULT_PATH).settings.linux.coordinator.agentMinFreeMemory, val !== undefined ? val : '');
                      })
                }, {
                  postpend: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }, 8, ["data-testid", "disabled", "error", "error-message", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode(TooltipBtn, {
                    "tooltip-width": 207,
                    "btn-icon": "icon-question-circle",
                    class: "ml-0.5 mb-0.5 tooltip-btn",
                    "tooltip-title": _ctx.$t('settings.general.linux.tooltipText.coordinator.agentReloadTimeout')
                  }, null, 8, ["tooltip-title"])
                ]),
                _createVNode(_unref(IncrediField), {
                  "data-testid": _unref(elementsIds).settings.form.linux.general.machineReloadTimeout,
                  disabled: !_unref(userRolePermissions).authorize?.value?.settings.enabled.general,
                  autocomplete: "off",
                  name: "description",
                  label: "Reload timeout",
                  type: "number",
                  size: "tiny",
                  class: "input-container",
                  error: _unref(validInputs)?.['settings.linux.coordinator.agentReloadTimeout'].isValid === false,
                  "error-message": _ctx.$t('settings.general.linux.validationsErrors.positiveNumbers'),
                  modelValue: 
                __props.settingsObject?.settings?.linux?.coordinator?.agentReloadTimeout || __props.settingsObject?.settings?.linux?.coordinator?.agentReloadTimeout === 0
                  ? __props.settingsObject?.settings?.linux?.coordinator?.agentReloadTimeout
                  : ''
              ,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = 
                      (val) => {
                        _unref(settingsDirty)?.setInputsDirty(_unref(QUERY_RESULT_PATH).settings.linux.coordinator.agentReloadTimeout, val !== undefined ? val : '');
                      })
                }, {
                  postpend: _withCtx(() => [
                    _hoisted_18
                  ]),
                  _: 1
                }, 8, ["data-testid", "disabled", "error", "error-message", "modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(IncrediCheckBox, {
                  "data-testid": _unref(elementsIds).settings.form.linux.general.autoSubscribeNewAgents,
                  disable: !_unref(userRolePermissions).authorize?.value?.settings.enabled.general,
                  class: "flex",
                  "label-for": "checkbox-ignore-firewall",
                  label: "Auto-subscribe new agents",
                  value: __props.settingsObject?.settings?.linux?.coordinator?.autoSubscribeNewAgents,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = 
                      (val) => {
                        _unref(settingsDirty)?.setInputsDirty(_unref(QUERY_RESULT_PATH).settings.linux.coordinator.autoSubscribeNewAgents, val !== undefined ? val : '');
                      })
                }, null, 8, ["data-testid", "disable", "value"]),
                _createVNode(TooltipBtn, {
                  "tooltip-width": 207,
                  "btn-icon": "icon-question-circle",
                  class: "ml-0.5 mb-0.5 tooltip-btn",
                  "tooltip-title": _ctx.$t('settings.general.linux.tooltipText.coordinator.autoSubscribeNewAgents')
                }, null, 8, ["tooltip-title"])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(IncrediCheckBox, {
                  "data-testid": _unref(elementsIds).settings.form.linux.general.telemetry,
                  disable: !_unref(userRolePermissions).authorize?.value?.settings.enabled.general,
                  class: "flex",
                  "label-for": "checkbox-telemetry",
                  label: "Help us improve our product & services",
                  value: __props.settingsObject?.settings?.linux?.system?.telemetryEnabled,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = 
                      (val) => {
                        _unref(settingsDirty)?.setInputsDirty(_unref(QUERY_RESULT_PATH).settings.linux.system.telemetryEnabled, val !== undefined ? val : '');
                      })
                }, null, 8, ["data-testid", "disable", "value"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(SettingsItemBox, {
          class: "w-full",
          header: _ctx.$t('settings.general.backup.title')
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('settings.general.backup.subTitle')), 1),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createVNode(TooltipBtn, {
                    "tooltip-width": 207,
                    "btn-icon": "icon-question-circle",
                    class: "ml-0.5 mb-0.5 tooltip-btn",
                    "tooltip-title": _ctx.$t('settings.general.linux.tooltipText.backup.backupCoordinatorHostname')
                  }, null, 8, ["tooltip-title"])
                ]),
                _createVNode(_unref(IncrediField), {
                  "data-testid": _unref(elementsIds).settings.form.linux.general.backupHost,
                  disabled: !_unref(userRolePermissions).authorize?.value?.settings.enabled.general,
                  autocomplete: "off",
                  name: "description",
                  label: "Hostame or IP",
                  type: "number",
                  size: "tiny",
                  class: "input-container",
                  modelValue: __props.settingsObject?.settings?.common?.backup?.otherCoordinatorName || '',
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = 
                      (val) => {
                        _unref(settingsDirty)?.setInputsDirty(_unref(QUERY_RESULT_PATH).settings.common.backup.otherCoordinatorName, val !== undefined ? val : '');
                      })
                }, null, 8, ["data-testid", "disabled", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createVNode(TooltipBtn, {
                    "tooltip-width": 207,
                    "btn-icon": "icon-question-circle",
                    class: "ml-0.5 mb-0.5 tooltip-btn",
                    "tooltip-title": _ctx.$t('settings.general.linux.tooltipText.backup.backupCoordinatorPort')
                  }, null, 8, ["tooltip-title"])
                ]),
                _createVNode(_unref(IncrediField), {
                  "data-testid": _unref(elementsIds).settings.form.linux.general.backupPort,
                  disabled: !_unref(userRolePermissions).authorize?.value?.settings.enabled.general,
                  autocomplete: "off",
                  name: "description",
                  label: "Sync port",
                  type: "number",
                  size: "tiny",
                  class: "input-container",
                  modelValue: __props.settingsObject?.settings?.common?.backup?.otherCoordinatorPort || '',
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = 
                      (val) => {
                        _unref(settingsDirty)?.setInputsDirty(_unref(QUERY_RESULT_PATH).settings.common.backup.otherCoordinatorPort, val !== undefined ? val : '');
                      })
                }, {
                  postpend: _withCtx(() => [
                    _createVNode(_unref(increaseDecreaseArrowsButton), {
                      class: "flex justify-center",
                      modelValue: __props.settingsObject?.settings?.common?.backup?.otherCoordinatorPort || 0,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = 
                      (val) => {
                        _unref(settingsDirty)?.setInputsDirty(_unref(QUERY_RESULT_PATH).settings.common.backup.otherCoordinatorPort, val || 0);
                      })
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["data-testid", "disabled", "modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createVNode(TooltipBtn, {
                    "tooltip-width": 207,
                    "btn-icon": "icon-question-circle",
                    class: "ml-0.5 mb-0.5 tooltip-btn",
                    "tooltip-title": _ctx.$t('settings.general.linux.tooltipText.backup.backupCoordinatorTimeout')
                  }, null, 8, ["tooltip-title"])
                ]),
                _createVNode(_unref(IncrediField), {
                  "data-testid": _unref(elementsIds).settings.form.linux.general.backupTimeout,
                  disabled: !_unref(userRolePermissions).authorize?.value?.settings.enabled.general,
                  autocomplete: "off",
                  name: "description",
                  label: "Timeout",
                  type: "number",
                  size: "tiny",
                  class: "input-container",
                  error: _unref(validInputs)?.['settings.common.backup.backupCoordinatorTimeout'].isValid === false,
                  "error-message": _ctx.$t('settings.general.linux.validationsErrors.backupTimeoutMinimum'),
                  modelValue: 
                __props.settingsObject?.settings?.common?.backup?.backupCoordinatorTimeout || __props.settingsObject?.settings?.common?.backup?.backupCoordinatorTimeout === 0
                  ? __props.settingsObject?.settings?.common?.backup?.backupCoordinatorTimeout
                  : ''
              ,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = 
                      (val) => {
                        _unref(settingsDirty)?.setInputsDirty(_unref(QUERY_RESULT_PATH).settings.common.backup.backupCoordinatorTimeout, val !== undefined ? val : '');
                      })
                }, {
                  postpend: _withCtx(() => [
                    _hoisted_34
                  ]),
                  _: 1
                }, 8, ["data-testid", "disabled", "error", "error-message", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _hoisted_37,
                  _createVNode(TooltipBtn, {
                    "tooltip-width": 207,
                    "btn-icon": "icon-question-circle",
                    class: "ml-0.5 mb-0.5 tooltip-btn",
                    "tooltip-title": _ctx.$t('settings.general.linux.tooltipText.backup.backupCoordinatorSyncFrequency')
                  }, null, 8, ["tooltip-title"])
                ]),
                _createVNode(_unref(IncrediField), {
                  "data-testid": _unref(elementsIds).settings.form.linux.general.backupSyncFrequency,
                  disabled: !_unref(userRolePermissions).authorize?.value?.settings.enabled.general,
                  autocomplete: "off",
                  name: "description",
                  label: "Sync frequency",
                  type: "number",
                  size: "tiny",
                  class: "input-container",
                  error: _unref(validInputs)?.['settings.common.backup.backupCoordinatorSyncFrequency'].isValid === false,
                  "error-message": _ctx.$t('settings.general.linux.validationsErrors.positiveNumbers'),
                  modelValue: 
                __props.settingsObject?.settings?.common?.backup?.backupCoordinatorSyncFrequency || __props.settingsObject?.settings?.common?.backup?.backupCoordinatorSyncFrequency === 0
                  ? __props.settingsObject?.settings?.common?.backup?.backupCoordinatorSyncFrequency
                  : ''
              ,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = 
                      (val) => {
                        _unref(settingsDirty)?.setInputsDirty(_unref(QUERY_RESULT_PATH).settings.common.backup.backupCoordinatorSyncFrequency, val !== undefined ? val : '');
                      })
                }, {
                  postpend: _withCtx(() => [
                    _hoisted_38
                  ]),
                  _: 1
                }, 8, ["data-testid", "disabled", "error", "error-message", "modelValue"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["header"])
      ]),
      _createElementVNode("div", _hoisted_39, [
        _createVNode(SettingsItemBox, {
          class: "w-full",
          header: _ctx.$t('settings.general.network.title')
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _hoisted_43,
                  _createVNode(TooltipBtn, {
                    "tooltip-width": 207,
                    "btn-icon": "icon-question-circle",
                    class: "ml-0.5 mb-0.5 tooltip-btn",
                    "tooltip-title": _ctx.$t('settings.general.linux.tooltipText.coordinator.utilityPort')
                  }, null, 8, ["tooltip-title"])
                ]),
                _createVNode(_unref(IncrediField), {
                  "data-testid": _unref(elementsIds).settings.form.linux.general.coordUtilityPort,
                  disabled: !_unref(userRolePermissions).authorize?.value?.settings.enabled.general,
                  autocomplete: "off",
                  name: "description",
                  label: "Utility port",
                  type: "number",
                  size: "tiny",
                  class: "input-container",
                  modelValue: __props.settingsObject?.settings?.linux?.coordinator?.utilityPort || '',
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = 
                      (val) => {
                        _unref(settingsDirty)?.setInputsDirty(_unref(QUERY_RESULT_PATH).settings.linux.coordinator.utilityPort, val !== undefined ? val : '');
                      })
                }, {
                  postpend: _withCtx(() => [
                    _createVNode(_unref(increaseDecreaseArrowsButton), {
                      class: "flex justify-center",
                      modelValue: __props.settingsObject?.settings?.linux?.coordinator?.utilityPort || 0,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = 
                      (val) => {
                        _unref(settingsDirty)?.setInputsDirty(_unref(QUERY_RESULT_PATH).settings.linux.coordinator.utilityPort, val || 0);
                      })
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["data-testid", "disabled", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _hoisted_46,
                  _createVNode(TooltipBtn, {
                    "tooltip-width": 207,
                    "btn-icon": "icon-question-circle",
                    class: "ml-0.5 mb-0.5 tooltip-btn",
                    "tooltip-title": _ctx.$t('settings.general.linux.tooltipText.coordinator.sessionPort')
                  }, null, 8, ["tooltip-title"])
                ]),
                _createVNode(_unref(IncrediField), {
                  "data-testid": _unref(elementsIds).settings.form.linux.general.coordSessionPort,
                  disabled: !_unref(userRolePermissions).authorize?.value?.settings.enabled.general,
                  autocomplete: "off",
                  name: "description",
                  label: "Session port",
                  type: "number",
                  size: "tiny",
                  class: "input-container",
                  modelValue: __props.settingsObject?.settings?.linux?.coordinator?.sessionPort || '',
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = 
                      (val) => {
                        _unref(settingsDirty)?.setInputsDirty(_unref(QUERY_RESULT_PATH).settings.linux.coordinator.sessionPort, val !== undefined ? val : '');
                      })
                }, {
                  postpend: _withCtx(() => [
                    _createVNode(_unref(increaseDecreaseArrowsButton), {
                      class: "flex justify-center",
                      modelValue: __props.settingsObject?.settings?.linux?.coordinator?.sessionPort || 0,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = 
                      (val) => {
                        _unref(settingsDirty)?.setInputsDirty(_unref(QUERY_RESULT_PATH).settings.linux.coordinator.sessionPort, val || 0);
                      })
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["data-testid", "disabled", "modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _hoisted_50,
                  _createVNode(TooltipBtn, {
                    "tooltip-width": 207,
                    "btn-icon": "icon-question-circle",
                    class: "ml-0.5 mb-0.5 tooltip-btn",
                    "tooltip-title": _ctx.$t('settings.general.network.coordPort.tooltip')
                  }, null, 8, ["tooltip-title"])
                ]),
                _createVNode(SettingsPortInput, {
                  "input-for": "ib-manager-port",
                  "data-testid": _unref(elementsIds).settings.form.linux.general.ibManagerPort,
                  mask: "#####",
                  disable: !_unref(userRolePermissions).authorize?.value?.settings.enabled.general,
                  loading: _unref(validPorts)?.['settings.common.ibManager.ibManagerPort'].isFetching,
                  error: _unref(validPorts)?.['settings.common.ibManager.ibManagerPort'].isValid === false,
                  "error-message": _unref(getPositivePortValidationErrorMessage)(__props.settingsObject?.settings?.common?.ibManager?.ibManagerPort || 0),
                  rules: [(value) => _unref(validPorts)?.['settings.common.ibManager.ibManagerPort'].isValid !== false || _unref(getPositivePortValidationErrorMessage)(value)],
                  value: __props.settingsObject?.settings?.common?.ibManager?.ibManagerPort,
                  "field-name": _unref(SETTINGS_OBJ).DashboardPort,
                  "is-port-valid": (_unref(validPorts)?.['settings.common.ibManager.ibManagerPort'].isValid as any),
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = 
                      (val) => {
                        _unref(settingsDirty)?.setInputsDirty(_unref(QUERY_RESULT_PATH).settings.common.ibManager.ibManagerPort, val);
                      }
                    )
                }, null, 8, ["data-testid", "disable", "loading", "error", "error-message", "rules", "value", "field-name", "is-port-valid"])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _hoisted_53,
                  _createVNode(TooltipBtn, {
                    "tooltip-width": 207,
                    "btn-icon": "icon-question-circle",
                    class: "ml-0.5 mb-0.5 tooltip-btn",
                    "tooltip-title": _ctx.$t('settings.general.linux.tooltipText.coordinator.agentControlPort')
                  }, null, 8, ["tooltip-title"])
                ]),
                _createVNode(_unref(IncrediField), {
                  "data-testid": _unref(elementsIds).settings.form.linux.general.agentControlPort,
                  disabled: !_unref(userRolePermissions).authorize?.value?.settings.enabled.general,
                  autocomplete: "off",
                  name: "description",
                  label: "Control port",
                  type: "number",
                  size: "tiny",
                  class: "input-container",
                  modelValue: __props.settingsObject?.settings?.linux?.coordinator?.agentControlPort || '',
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = 
                      (val) => {
                        _unref(settingsDirty)?.setInputsDirty(_unref(QUERY_RESULT_PATH).settings.linux.coordinator.agentControlPort, val !== undefined ? val : '');
                      })
                }, {
                  postpend: _withCtx(() => [
                    _createVNode(_unref(increaseDecreaseArrowsButton), {
                      class: "flex justify-center",
                      modelValue: __props.settingsObject?.settings?.linux?.coordinator?.agentControlPort || 0,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = 
                      (val) => {
                        _unref(settingsDirty)?.setInputsDirty(_unref(QUERY_RESULT_PATH).settings.linux.coordinator.agentControlPort, val || 0);
                      })
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["data-testid", "disabled", "modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, [
                  _hoisted_57,
                  _createVNode(TooltipBtn, {
                    "tooltip-width": 207,
                    "btn-icon": "icon-question-circle",
                    class: "ml-0.5 mb-0.5 tooltip-btn",
                    "tooltip-title": _ctx.$t('settings.general.linux.tooltipText.network.webserverPort')
                  }, null, 8, ["tooltip-title"])
                ]),
                _createVNode(_unref(IncrediField), {
                  "data-testid": _unref(elementsIds).settings.form.linux.general.webserverPort,
                  disabled: !_unref(userRolePermissions).authorize?.value?.settings.enabled.general,
                  autocomplete: "off",
                  name: "description",
                  label: "Webserver port",
                  type: "number",
                  size: "tiny",
                  class: "input-container",
                  error: _unref(validInputs)?.['settings.linux.network.coordinatorPort'].isValid === false,
                  "error-message": _ctx.$t('settings.general.linux.validationsErrors.portInUse'),
                  modelValue: __props.settingsObject?.settings?.linux?.network?.coordinatorPort || '',
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = 
                      (val) => {
                        _unref(settingsDirty)?.setInputsDirty(_unref(QUERY_RESULT_PATH).settings.linux.network.coordinatorPort, val || 0);
                        _unref(validateApachePorts) && _unref(validateApachePorts)(_unref(QUERY_RESULT_PATH).settings.linux.network.coordinatorPort, val, __props.settingsObject?.settings?.linux?.network?.coordinatorSSLPort || 0);
                     })
                }, {
                  postpend: _withCtx(() => [
                    _createVNode(_unref(increaseDecreaseArrowsButton), {
                      class: "flex justify-center",
                      modelValue: __props.settingsObject?.settings?.linux?.network?.coordinatorPort || 0,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = 
                      (val) => {
                         _unref(settingsDirty)?.setInputsDirty(_unref(QUERY_RESULT_PATH).settings.linux.network.coordinatorPort, val || 0);
                         _unref(validateApachePorts) && _unref(validateApachePorts)(_unref(QUERY_RESULT_PATH).settings.linux.network.coordinatorPort, val, __props.settingsObject?.settings?.linux?.network?.coordinatorSSLPort || 0);
                     })
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["data-testid", "disabled", "error", "error-message", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  _hoisted_60,
                  _createVNode(TooltipBtn, {
                    "tooltip-width": 207,
                    "btn-icon": "icon-question-circle",
                    class: "ml-0.5 mb-0.5 tooltip-btn",
                    "tooltip-title": _ctx.$t('settings.general.linux.tooltipText.network.httpsWebserverPort')
                  }, null, 8, ["tooltip-title"])
                ]),
                _createVNode(_unref(IncrediField), {
                  "data-testid": _unref(elementsIds).settings.form.linux.general.webserverSslPort,
                  disabled: !_unref(userRolePermissions).authorize?.value?.settings.enabled.general,
                  autocomplete: "off",
                  name: "description",
                  label: "HTTPS webserver port",
                  type: "number",
                  size: "tiny",
                  class: "input-container",
                  error: _unref(validInputs)?.['settings.linux.network.coordinatorSSLPort'].isValid === false,
                  "error-message": _ctx.$t('settings.general.linux.validationsErrors.portInUse'),
                  modelValue: __props.settingsObject?.settings?.linux?.network?.coordinatorSSLPort || '',
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = 
                      (val) => {
                        _unref(settingsDirty)?.setInputsDirty(_unref(QUERY_RESULT_PATH).settings.linux.network.coordinatorSSLPort, val !== undefined ? val : '');
                        _unref(validateApachePorts) && _unref(validateApachePorts)(_unref(QUERY_RESULT_PATH).settings.linux.network.coordinatorSSLPort, val, __props.settingsObject?.settings?.linux?.network?.coordinatorPort || 0);
                      })
                }, {
                  postpend: _withCtx(() => [
                    _createVNode(_unref(increaseDecreaseArrowsButton), {
                      class: "flex justify-center",
                      modelValue: __props.settingsObject?.settings?.linux?.network?.coordinatorSSLPort || 0,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = 
                      (val) => {
                        _unref(settingsDirty)?.setInputsDirty(_unref(QUERY_RESULT_PATH).settings.linux.network.coordinatorSSLPort, val || 0);
                        _unref(validateApachePorts) && _unref(validateApachePorts)(_unref(QUERY_RESULT_PATH).settings.linux.network.coordinatorSSLPort, val, __props.settingsObject?.settings?.linux?.network?.coordinatorPort || 0);
                      })
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["data-testid", "disabled", "error", "error-message", "modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, [
                _createVNode(IncrediCheckBox, {
                  "data-testid": _unref(elementsIds).settings.form.linux.general.ipv6Checkbox,
                  disable: !_unref(userRolePermissions).authorize?.value?.settings.enabled.general,
                  class: "flex",
                  "label-for": "checkbox-ignore-firewall",
                  label: "IPv6 network",
                  value: __props.settingsObject?.settings?.linux?.network?.ipv6,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = 
                      (val) => {
                        _unref(settingsDirty)?.setInputsDirty(_unref(QUERY_RESULT_PATH).settings.linux.network.ipv6, val !== undefined ? val : '');
                      })
                }, null, 8, ["data-testid", "disable", "value"]),
                _createVNode(TooltipBtn, {
                  "tooltip-width": 207,
                  "btn-icon": "icon-question-circle",
                  class: "ml-0.5 mb-0.5 tooltip-btn",
                  "tooltip-title": _ctx.$t('settings.general.linux.tooltipText.network.ipv6')
                }, null, 8, ["tooltip-title"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["header"]),
        (!!_unref(featureFlags)?.auth)
          ? (_openBlock(), _createBlock(SettingsActiveDirectory, {
              key: 0,
              enabled: !!__props.settingsObject?.settings?.common?.auth?.enabled,
              auth: __props.settingsObject?.settings?.common?.auth as Settings_ExternalAuth
            }, null, 8, ["enabled", "auth"]))
          : _createCommentVNode("", true),
        _createVNode(SettingsItemBox, {
          class: "w-full",
          header: _ctx.$t('settings.general.linux.general.ssl.title')
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, [
                  _createVNode(IncrediCheckBox, {
                    "data-testid": _unref(elementsIds).settings.form.linux.general.ssl,
                    disable: !_unref(userRolePermissions).authorize?.value?.settings.enabled.general,
                    class: "flex",
                    "label-for": "checkbox-ssl",
                    label: "Enable SSL",
                    value: __props.settingsObject?.settings?.linux?.network?.ssl,
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = 
                      (val) => {
                        _unref(settingsDirty)?.setInputsDirty(_unref(QUERY_RESULT_PATH).settings.linux.network.ssl, val !== undefined ? val : '');
                      })
                  }, null, 8, ["data-testid", "disable", "value"]),
                  _createVNode(TooltipBtn, {
                    "tooltip-width": 207,
                    "btn-icon": "icon-question-circle",
                    class: "ml-0.5 mb-0.5 tooltip-btn",
                    "tooltip-title": _ctx.$t('settings.general.linux.tooltipText.network.ssl')
                  }, null, 8, ["tooltip-title"])
                ]),
                _createElementVNode("div", null, [
                  _createVNode(IncrediCheckBox, {
                    "data-testid": _unref(elementsIds).settings.form.linux.general.ssl,
                    disable: !_unref(userRolePermissions).authorize?.value?.settings.enabled.general,
                    class: "flex",
                    "label-for": "checkbox-useCoordinatorAgentTunnel",
                    label: _ctx.$t('settings.general.linux.general.ssl.useCoordinatorAgentTunnel.title'),
                    value: __props.settingsObject?.settings?.linux?.network?.useCoordinatorAgentTunnel,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = 
                      (val) => {
                        _unref(settingsDirty)?.setInputsDirty(_unref(QUERY_RESULT_PATH).settings.linux.network.useCoordinatorAgentTunnel, val !== undefined ? val : '');
                      })
                  }, null, 8, ["data-testid", "disable", "label", "value"]),
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.$t('settings.general.linux.general.ssl.useCoordinatorAgentTunnel.description')), 1)
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["header"])
      ])
    ]),
    _: 1
  }))
}
}

})